import { FormOptions, wrapForm } from 'components/shared/form';

import { plugins } from 'forms/utils/formPlugins';
import { formOptions } from 'forms/utils/formOptions';
import CommercialReimbursements from './CommercialReimbursements';

const formConfig: FormOptions = {
  fields: [
    {
      name: 'incomeApproach',
      fields: [
        {
          name: 'commercial',
          fields: [
            {
              name: 'reimbursements',
              type: 'array',
              value: [],
            },
            // {
            //   name: 'reimbursements[]',
            //   fields: [
            //     {
            //       name: 'key',
            //       type: 'text',
            //       value: '',
            //     },
            //     {
            //       name: 'name',
            //       type: 'text',
            //       value: '',
            //     },
            //     {
            //       name: 'expenseCategory',
            //       type: 'text',
            //       value: '',
            //     },
            //     {
            //       name: 'reimbursementType',
            //       type: 'text',
            //       value: '',
            //     },
            //     {
            //       name: 'dollarAmountType',
            //       type: 'text',
            //       value: '',
            //     },
            //     {
            //       name: 'adminFeeKnown',
            //       type: 'boolean',
            //     },
            //     {
            //       name: 'grossVCLoss',
            //       type: 'number',
            //       value: 0,
            //     },
            //     {
            //       name: 'vcLoss',
            //       type: 'number',
            //       value: 0,
            //     },
            //     {
            //       name: 'grossAnnualValue',
            //       type: 'number',
            //       value: 0,
            //     },
            //     {
            //       name: 'effectiveAnnualValue',
            //       type: 'number',
            //       value: 0,
            //     },
            //     {
            //       name: 'unitReimbursements',
            //       type: 'array',
            //       value: [],
            //     },
            //   ],
            // },
          ],
        },
      ],
    },
  ],
  options: {
    ...formOptions,
    validateOnChange: true,
  },
  plugins,
};

export default wrapForm(formConfig)(CommercialReimbursements);
